<template>
  <transition-group name="fade">
    <q-layout v-if="appLoaded" view="lHh LpR lFf">
      <Drawer v-if="!$route.meta.hideDrawer && currentUser?.uid" />
      <FooterNav v-if="!$route.meta.hideFooter" />
      <q-page-container v-if="currentUser?.uid && currentOrganization && subscriptionEnds < new Date()">
        <q-page padding class="q-mt-lg">
          <Pay :organization="currentOrganization" isFirstPayment />
        </q-page>
      </q-page-container>
      <router-view v-else :key="$route.path" />
      <RecordWidget v-if="currentUser?.uid" />
      <PlayerWidget v-if="currentUser?.uid" />
    </q-layout>
    <q-inner-loading v-else showing>
      <q-spinner-bars size="50px" color="accent" />
    </q-inner-loading>
  </transition-group>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { defineAsyncComponent } from 'vue';
const FooterNav = defineAsyncComponent(() => import('@/components/blocks/Footer/FooterNav.vue'));
const RecordWidget = defineAsyncComponent(() => import('@/components/blocks/RecordWidget/RecordWidget.vue'));
const PlayerWidget = defineAsyncComponent(() => import('@/components/blocks/PlayerWidget.vue'));
import Drawer from '@/components/blocks/Drawer.vue';
import Pay from '@/components/blocks/Pay.vue';
import { getAppUpdateUrl } from './utils/getAppUpdateUrl';
import { tabOutlineInfoCircle } from 'quasar-extras-svg-icons/tabler-icons-v3';

export default {
  components: {
    RecordWidget,
    PlayerWidget,
    FooterNav,
    Drawer,
    Pay,
  },
  computed: {
    ...mapState(['appLoaded', 'currentUser', 'subscriptionEnds']),
    ...mapGetters(['currentOrganization']),
  },
  async beforeMount() {
    if (this.$cookies.get('darkmode')) {
      const darkMode = this.$cookies.get('darkmode') === 'true';
      this.$q.dark.set(darkMode);
    } else {
      this.$q.dark.set(false);
    }
    try {
      const response = await this.$store.dispatch('check');
      if (response.isNewVersionAvailable) {
        this.$q.notify({
          message: 'New version available',
          position: 'top',
          multiLine: false,
          icon: tabOutlineInfoCircle,
          timeout: 0,
          actions: [
            {
              label: 'Update',
              color: 'white',
              textColor: 'primary',
              dense: true,
              class: 'q-px-md on-right text-caption',
              rounded: true,
              flat: false,
              handler: () => window.open(getAppUpdateUrl()),
            },
            {
              color: 'white',
              rounded: true,
              class: 'q-px-md on-right text-caption',
              label: 'Dismiss',
            },
          ],
        });
      }
    } catch (err) {
      if (err.message === 'Network Error') {
        return;
      }
      this.$q
        .dialog({
          title: 'Version Update',
          message: 'There is a new version available. Please update to the latest version.',
          persistent: true,
          ok: {
            label: 'Update',
            rounded: true,
          },
          actions: [],
        })
        .onOk(() => {
          window.open(getAppUpdateUrl());
          location.reload();
        });
    }
  },
};
</script>

<style lang="scss"></style>
